/* eslint-disable */
export const slugify = (string) => {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
    const p = new RegExp(a.split('').join('|'), 'g');
    return string.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(p, c => b.charAt(a.indexOf(c)))
        .replace(/&/g, '-and-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}

export const get_player_from_roster_by_slug = (slug, roster) => {
    return roster.find((player) => player.slug === slug);
}

export const get_players_from_roster_by_count = (count, roster) => {
    return roster.slice(0, count);
}

export const get_players_from_roster_by_state = (state, roster) => {
    return roster.filter((player) => player.state.toLowerCase() === state);
}

export const guid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export const sort_by = (property_name) => {
    return (a,b) => (a[property_name] < b[property_name]) ? -1 : (a[property_name] > b[property_name]) ? 1 : 0;
}